/* eslint-disable */
class ItemSettingBuilding {
  constructor() {
    this._buildingType = {
      tourism: {
        default: {
          create: false,
          depth: 0.25
        },
        hotel: {
          depth: 0.3,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        attraction: {
          depth: 0.0125,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        }
      },
      amenity: {
        default: {
          create: false,
          depth: 0.25
        },
        cafe: {
          depth: 0.012,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        parking: {
          depth: 0.013,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        hospital: {
          depth: 0.014,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        fountain: {
          depth: 0.015,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        restaurant: {
          depth: 0.016,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        place_of_worship: {
          depth: 0.017,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        public_building: {
          depth: 0.018,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        } /*
        university: {
          depth: 0.019,
          color: new BABYLON.Color3(0.25, 0.25, 0.25)
        },*/,
        college: {
          depth: 0.02,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        }
      },
      landuse: {
        default: {
          create: false,
          depth: 0.25
        },
        military: {
          depth: 0.3,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        forest: {
          depth: 0.0025,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        }
        /*retail: {
          depth: 0.0025,
          color: new BABYLON.Color3(0.75, 0.5, 0.5)
        }*/
      },
      natural: {
        default: {
          create: true,
          depth: 0.25
        },
        wood: {
          depth: 0.05,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        }
      },
      leisure: {
        default: {
          create: false,
          depth: 0.25
        },
        swimming_pool: {
          depth: 0.05,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        residential: {
          depth: 0.051,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        pitch: {
          depth: 0.052,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        park: {
          depth: 0.053,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        garden: {
          depth: 0.054,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        stadium: {
          depth: 0.025,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        }
      },
      waterway: {
        default: {
          create: false,
          depth: 0.25
        },
        riverbank: {
          depth: 0.01,
          color: new BABYLON.Color3(0.75, 0.75, 0.75),
          metallic: 0.75,
          roughness: 0.2
        }
      },
      building: {
        default: {
          create: true,
          depth: 0.25
        },
        retail: {
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        train_station: {
          depth: 0.3,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        commercial: {
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        office: {
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        school: {
          depth: 0.25,
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        },
        apartments: {
          color: new BABYLON.Color3(0.75, 0.75, 0.75)
        }
      }
    };
  }

  get buildingType() {
    return this._buildingType;
  }
}

export default new ItemSettingBuilding();
